import Dexie from "dexie";

const dexieDB = new Dexie("daffi");

dexieDB.version(1).stores({
	deviceInfo: "++id, data",
	localUsers: "++id, data",
	daffiUsers: "++id, data",
	profiles: "++id, userID, data",
	contacts: "++id, userID, data",
	settings: "++id, userID, data",
	tAlgoAccounts: "++id, userID, data",
	tAlgoSecretKeys: "++id, userID, data",
});

dexieDB.open().catch((e) => {
	console.error(`Open failed: ${e.stack}`);
});

export default dexieDB;

//******************************************
// Function to add a user
//******************************************

// export const addUser = (data) => {
// 	dexieDB.localUsers.add({ data: JSON.stringify(data) }).then((id) => {
// 		console.log("User added with ID: ", id);
// 	});
// };

//******************************************
// Function to get all localUsers
//******************************************

// export const getUsers = () => {
// 	return dexieDB.localUsers.toArray().then((localUsers) => {
// 		return localUsers.map((user) => JSON.parse(user.data));
// 	});
// };

//******************************************
// Function to get a user by ID
//******************************************

// export const getUser = (id) => {
// 	return dexieDB.localUsers.get(id).then((user) => {
// 		if (user) {
// 			return JSON.parse(user.data);
// 		}
// 	});
// };

//******************************************
// Function to get a user by json data property
//******************************************

// export const getUser = (deviceID) => {
// 	return dexieDB.deviceInfo
// 		.filter((deviceInfo) => JSON.parse(deviceInfo.data)["device-id"] === deviceID)
// 		.first()
// 		.then((deviceInfo) => {
// 			if (deviceInfo) {
// 				return JSON.parse(deviceInfo.data);
// 			}
// 		});
// };

//******************************************
// Function to update a user by ID
//******************************************

// export const updateUser = (id, data) => {
// 	return dexieDB.localUsers.update(id, { data: JSON.stringify(data) }).then((updateCount) => {
// 		console.log(`User updated. Update count: ${updateCount}`);
// 	});
// };

//******************************************
// Function to delete a user by ID
//******************************************

// export const deleteUser = (id) => {
// 	return dexieDB.localUsers.delete(id).then((deleteCount) => {
// 		console.log(`User deleted. Delete count:${deleteCount}`);
// 	});
// };

// export function deleteUser(id) {
// 	return (dispatch) => {
// 		dexieDB.localUsers.delete(id).then(() => {
// 			// Dispatch an action to update the state
// 			dispatch({ type: "DELETE_USER", payload: id });
// 		});
// 	};
// }
